import React from 'react';
import NewBlogCardDetailVersion from '@/components/reusable/NewBlogCardDetailVersion/NewBlogCardDetailVersion';

const BlogDetailsView = ({ blogDetail, setShowDetail }) => {
  return (
    <NewBlogCardDetailVersion
      blogDetail={blogDetail}
      setShowDetail={setShowDetail}
    />
  );
};

export default BlogDetailsView;
